import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, AlertTriangle, Users, FileText, ScanFace, Shield, Heart } from 'lucide-react';
import { Button } from '../components/ui/button';

const DesktopNav = () => {
  const location = useLocation();
  const path = location.pathname;

  const isActive = (itemPath) => {
    if (itemPath === '/') return path === '/';
    return path.startsWith(itemPath);
  };

  const navLinks = [
    { path: '/', label: 'होम' },
    { path: '/missing', label: 'लापता', icon: AlertTriangle, color: 'text-red-600' },
    { path: '/unknown', label: 'अज्ञात व्यक्ति', icon: Users, color: 'text-amber-600' },
    { path: '/search', label: 'खोजें', icon: Search },
    { path: '/face-match', label: 'AI मिलान', icon: ScanFace, color: 'text-violet-600' },
    { path: '/shokh-sandesh', label: 'शोक संदेश', icon: Heart, color: 'text-gray-600' },
  ];

  return (
    <header className="desktop-nav sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-gray-200" data-testid="desktop-nav">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
            <img src="/gumsuda-logo.png" alt="गुमसुदा" className="h-11 w-auto object-contain" />
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.path.replace('/', '') || 'home'}`}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all flex items-center gap-2 ${
                  isActive(link.path) 
                    ? 'bg-gray-900 text-white' 
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                }`}
              >
                {link.icon && <link.icon className={`w-4 h-4 ${!isActive(link.path) && link.color ? link.color : ''}`} />}
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-3">
            <Link to="/submit">
              <Button className="bg-red-600 hover:bg-red-700 rounded-lg font-medium shadow-lg shadow-red-600/20 hover:shadow-red-600/40 transition-all btn-animated" data-testid="nav-submit">
                <FileText className="w-4 h-4 mr-2" />
                रिपोर्ट दर्ज करें
              </Button>
            </Link>
            <Link to="/admin" data-testid="nav-admin">
              <Button variant="outline" size="icon" className="rounded-lg">
                <Shield className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DesktopNav;
